import { SecondarySmallButton } from 'components/ReusableComponents/Button/SmallButtons'
import PublishBubble from 'features/PublishCampaign/PublishBubble'
import { useHistory } from 'react-router'

import styles from './ContentVariants.module.scss'
import { PublishRow } from './PublishRow'

const ContentVariants = ({
  readyToPublish,
  alreadyPublished,
  previousContent,
  currentContent,
  setContentId
}) => {
  const history = useHistory()

  return (
    <div className={styles.wrapper}>
      <div>
        <div className={styles.header}>
          <p className={styles.variantsTitle}>Content variants</p>
          <SecondarySmallButton onClick={() => history.goBack()}>
            &#8592; Go back to edit
          </SecondarySmallButton>
        </div>
        <div className={styles.rowHolder}>
          {alreadyPublished && (
            <PublishRow
              key={alreadyPublished.id}
              isAlreadyPublished
              hotelsLength={alreadyPublished.usedBy.length}
              firstHotelName={alreadyPublished.usedBy[0].hotelName}
              matchPercentage={100}
            />
          )}
          {readyToPublish.map(item => (
            <PublishRow
              key={item.id}
              isAlreadyPublished={false}
              hotelsLength={item.usedBy.length}
              matchPercentage={item.matchPercentage}
              firstHotelName={item.usedBy[0].hotelName}
              onPublishClick={() => setContentId(item.id)}
            />
          ))}
        </div>
      </div>
      <div className={styles.sidebar}>
        <p className={styles.sidebarTitle}>Changes to publish</p>
        <div className={styles.bubbleHolder}>
          <PublishBubble isPrevious text={previousContent} />
        </div>
        <div className={styles.bubbleHolder}>
          <PublishBubble text={currentContent} />
        </div>
      </div>
    </div>
  )
}

export default ContentVariants
